var backendurl = process.env.REACT_APP_BACKEND_URL;
// var backendurl = "https://admin.conativeitsolutions.com/";
// var backendurl = "https://test-nodelive.herokuapp.com/";

export default backendurl;